/**
 * Google Ad Manager 広告表示制御
 * - スマホ用広告の表示/非表示を制御（フッターメニューの上に固定表示）
 * - 画面遷移のたびに広告を再読み込み
 */

function updateAdVisibility() {
  // DOMが更新されるのを待つため、requestAnimationFrameを使用
  // requestAnimationFrame(() => {
  //   const adWrapperMobile = document.getElementById('ad-placeholder-wrapper-mobile');
    
  //   if (!adWrapperMobile) {
  //     // 要素がまだ存在しない場合は、少し待って再試行
  //     setTimeout(updateAdVisibility, 100);
  //     return;
  //   }

  //   const currentUrl = window.location.pathname;
  //   const showAdPages = [
  //     // '/dashboards',
  //     // '/memos',
  //     '/calendars'
  //   ];

  //   const shouldShow = showAdPages.some(path => currentUrl.startsWith(path));
    
  //   // スマホ用広告の表示/非表示を制御
  //   const contentMain = document.getElementById('content-main');
    
  //   if (shouldShow) {
  //     adWrapperMobile.classList.remove('hidden');
  //     // コンテンツエリアにクラスを追加（CSSでパディングを設定）
  //     if (contentMain) {
  //       contentMain.classList.add('has-mobile-ad');
  //     }
  //   } else {
  //     adWrapperMobile.classList.add('hidden');
  //     // コンテンツエリアのクラスを削除
  //     if (contentMain) {
  //       contentMain.classList.remove('has-mobile-ad');
  //     }
  //   }
  // });
}

/**
 * 広告を再読み込み
 * Google Ad Managerの広告を再読み込み
 */
function refreshAds() {
  if (window.googletag && window.googletag.apiReady) {
    googletag.cmd.push(function() {
      googletag.pubads().refresh();
    });
  }
}

// ページ読み込み時とTurbo遷移時に実行
document.addEventListener('turbo:load', () => {
  updateAdVisibility();
  // 画面遷移時に広告を再読み込み
  refreshAds();
});

document.addEventListener('turbo:frame-load', updateAdVisibility);

// Turbo Streamリクエスト時にも実行（ドロワーからの遷移に対応）
document.addEventListener('turboStreamRequest', () => {
  // URLが更新されるのを待つ
  setTimeout(() => {
    updateAdVisibility();
    refreshAds();
  }, 50);
});

// Turbo Streamのレンダリング後にも実行
document.addEventListener('turbo:stream-render', () => {
  // URLが更新されるのを待つ
  setTimeout(() => {
    updateAdVisibility();
    refreshAds();
  }, 50);
});

// 初回読み込み時も実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    updateAdVisibility();
    refreshAds();
  });
} else {
  updateAdVisibility();
  refreshAds();
}